import React from 'react'
import { formatNumber } from '../utils'

const KPISection = ({ items = [], loading }) => {
  if (!items.length && !loading) {
    return null
  }

  const gridClassName = `dashboard-kpis-grid dashboard-kpis-grid--count-${items.length}`

  return (
    <div className={gridClassName}>
      {items.map((item) => (
        <div className={`kpi-card accent-${item.accent || 'slate'}`} key={item.key}>
          <div className="kpi-icon">
            <i className={item.icon}></i>
          </div>
          <div className="kpi-content">
            <p className="kpi-label">{item.label}</p>
            <h4 className="kpi-value">
              {loading ? <span className="skeleton-line" /> : formatNumber(item.value)}
            </h4>
            {item.helper && (
              <span className="kpi-helper">{item.helper}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default KPISection

